import { useAuth } from '../contexts/AuthContext';
import GoogleAuth from './GoogleAuth';
import UserRegistrationForm from './UserRegistrationForm';
import { Container, Box, Typography } from '@mui/material';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, isLoading, needsRegistration, login, completeRegistration } = useAuth();

  if (isLoading) {
    return (
      <Container maxWidth="sm" sx={{ paddingTop: 4 }}>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
          <Typography>Loading...</Typography>
        </Box>
      </Container>
    );
  }

  if (!isAuthenticated) {
    return (
      <Container maxWidth="sm" sx={{ paddingTop: 4 }}>
        <GoogleAuth
          onAuthSuccess={login}
          onAuthFailure={(error) => {
            console.error('Authentication failed:', error);
          }}
        />
      </Container>
    );
  }

  if (needsRegistration) {
    return (
      <UserRegistrationForm onComplete={completeRegistration} />
    );
  }

  return children;
};

export default PrivateRoute;